import { defineStore } from 'pinia';
var useSendNFTStoreDefinition = defineStore('sendNFT', {
  state: function state() {
    return {
      user: null
    };
  },
  getters: {
    getUser: function getUser(state) {
      return state.user;
    }
  },
  actions: {
    setUser: function setUser(payload) {
      this.user = payload;
    },
    clearUser: function clearUser() {
      this.user = null;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useSendNFTStoreDefinition directly as
// useSendNFTStore instead.
export function useSendNFTStore() {
  return useSendNFTStoreDefinition(usePinia());
}